import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "pt-2 pl-4",
  style: {"font-weight":"bold"}
}
const _hoisted_2 = {
  class: "pt-2 pl-4",
  style: {"font-weight":"bold"}
}

import { computed } from 'vue';
import InputTimesForm from "@/components/OperationOfficeForms/InputTimesForm.vue"
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'IttenkoTimesForm',
  props: {
    windowInnerWidth: {},
    modelValue: {},
    errors: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;
const props = __props;

const maxlengths = {
  hours: 1,
  minutes: 2
}


const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", {
      value
    });
  },
});

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, { class: "radio-form pl-4 pr-3 mb-2" }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_v_col, { cols: "4" }, {
          default: _withCtx(() => [
            _createElementVNode("h6", _hoisted_1, _toDisplayString(_unref(i18n).global.t('pages.operationOffices.form.ittenko.acquisitionTime')), 1)
          ]),
          _: 1
        }, 512), [
          [_vShow, __props.windowInnerWidth < 800]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { class: "pl-4 pr-3 mb-2" }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_v_col, { cols: "2" }, {
          default: _withCtx(() => [
            _createElementVNode("h6", _hoisted_2, _toDisplayString(_unref(i18n).global.t('pages.operationOffices.form.ittenko.acquisitionTime')), 1)
          ]),
          _: 1
        }, 512), [
          [_vShow, __props.windowInnerWidth > 800]
        ]),
        _createVNode(InputTimesForm, {
          title: _unref(i18n).global.t('pages.operationOffices.form.ittenko.beforeLeaving'),
          modelValue: modelValue.value.ittenko_before_leaving,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue.value.ittenko_before_leaving) = $event)),
          windowInnerWidth: __props.windowInnerWidth,
          maxlength: maxlengths,
          errors: {
        hours: props.errors.ittenko_before_leaving_hours ?? [],
        minutes: props.errors.ittenko_before_leaving_minutes ?? []
      }
        }, null, 8, ["title", "modelValue", "windowInnerWidth", "errors"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { class: "pl-4 pr-3 mb-4" }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_v_col, { cols: "2" }, null, 512), [
          [_vShow, __props.windowInnerWidth > 800]
        ]),
        _createVNode(InputTimesForm, {
          title: _unref(i18n).global.t('pages.operationOffices.form.ittenko.afterReturning'),
          modelValue: modelValue.value.ittenko_after_returning,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue.value.ittenko_after_returning) = $event)),
          windowInnerWidth: __props.windowInnerWidth,
          maxlength: maxlengths,
          errors: {
        hours: props.errors.ittenko_after_returning_hours ?? [],
        minutes: props.errors.ittenko_after_returning_minutes ?? []
      }
        }, null, 8, ["title", "modelValue", "windowInnerWidth", "errors"])
      ]),
      _: 1
    })
  ], 64))
}
}

})